import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, path, data) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken]
  );
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return `Geçersiz değer: ${d.map((x) => x.loc?.slice(-1)[0]).join(", ")}`;
  return (typeof d === "string" && d) || e?.message || "Bilinmeyen hata";
};
